export function medicationApplicationListPendingMedicationsFilterByDate(
  initialPeriod
) {
  const query = `{
    medicationApplicationList(filter: {initialPeriod: ${initialPeriod}}) {
            dateFilter,
                listOfPendingMedications{
                    id,
                    medication{ id, name, dosage, routeAdministration, observation, requestDate, requester, photoRecipeUrl,student{ id, fullName, classesNames } },
                shouldApplicationDate,
                    shouldApplicationHour,
                    employeeApplication{ id, name },
                applicationDate,
                    applicationStatus,
                    observation
            },
       
        }
    }`;
  return query;
}

export function medicationApplicationListFinishedMedicationsFilterByDate(
  initialPeriod
) {
  const query = `{
    medicationApplicationList(filter: { initialPeriod: ${initialPeriod}}) {
      dateFilter,
        listOfFinishedMedications{
          id,
          medication{ id, name, dosage, routeAdministration, observation, initialDate, finalDate, hour01, hour02, hour03, hour04, hour05, requestDate, requester, photoRecipeUrl, employeeCreatorMed, student{ id, fullName, classesNames } },
        shouldApplicationDate,
          shouldApplicationHour,
          employeeApplication{ id, name },
        applicationDate,
          applicationStatus,
          observation
      }
    }
  }`;
  return query;
}

export function saveMutation(values) {
  const itemsToUpdate = values.map((item) => ({
    id: item.id,
    applicationStatus: item.applicationStatus,
    observation: item.observation,
    studentId: item.studentId,
  }));
  const mutationQuery = `mutation{    
    medicationApplicationSave(medicationApplications: ${JSON.stringify(
      itemsToUpdate
    ).replace(/"([^(")"]+)":/g, '$1:')},){medicationApplications:id}
}
`;
  return mutationQuery;
}
